// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#ar-prompt {
  position: absolute;
  left: 50%;
  bottom: 60px;
  animation: 2s ease-in-out 0s infinite alternate none running elongate;
  animation-duration: 2s;
  animation-timing-function: ease-in-out;
  animation-delay: 0s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  animation-fill-mode: none;
  animation-play-state: running;
  animation-name: elongate;
  display: none;
}

@keyframes elongate {
  from {
    transform: translateX(100px);
  }
  to {
    transform: translateX(-100px);
  }
}
@keyframes circle {
  from {
    transform: translateX(-50%) rotate(0deg) translateX(50px) rotate(0deg);
  }
  to {
    transform: translateX(-50%) rotate(360deg) translateX(50px) rotate(-360deg);
  }
}
#ar-prompt > img {
  animation: circle 4s linear infinite;
}

model-viewer {
  width: 100%;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/ar-viewer/ArViewer.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,qEAAA;EACA,sBAAA;EACA,sCAAA;EACA,mBAAA;EACA,mCAAA;EACA,8BAAA;EACA,yBAAA;EACA,6BAAA;EACA,wBAAA;EACA,aAAA;AACF;;AAEA;EACE;IACE,4BAAA;EACF;EACA;IACE,6BAAA;EACF;AACF;AAEA;EACE;IACE,sEAAA;EAAF;EAEA;IACE,2EAAA;EAAF;AACF;AAGA;EACE,oCAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;AADF","sourcesContent":["#ar-prompt {\n  position: absolute;\n  left: 50%;\n  bottom: 60px;\n  animation: 2s ease-in-out 0s infinite alternate none running elongate;\n  animation-duration: 2s;\n  animation-timing-function: ease-in-out;\n  animation-delay: 0s;\n  animation-iteration-count: infinite;\n  animation-direction: alternate;\n  animation-fill-mode: none;\n  animation-play-state: running;\n  animation-name: elongate;\n  display: none;\n}\n\n@keyframes elongate {\n  from {\n    transform: translateX(100px);\n  }\n  to {\n    transform: translateX(-100px);\n  }\n}\n\n@keyframes circle {\n  from {\n    transform: translateX(-50%) rotate(0deg) translateX(50px) rotate(0deg);\n  }\n  to {\n    transform: translateX(-50%) rotate(360deg) translateX(50px) rotate(-360deg);\n  }\n}\n\n#ar-prompt > img {\n  animation: circle 4s linear infinite;\n}\n\nmodel-viewer {\n  width: 100%;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
